import { reactive, readonly } from 'vue';
import { getEntityFieldMapping, getEnvConfig } from '@/utils/env-config';

/**
 *
 * @param {*} entity 对象id fieldMappings
 * @returns
 */
export function useEnvConfig(entity) {
  const fieldMappings = reactive(getEntityFieldMapping(entity) || {});
  const config = reactive(getEnvConfig() || {});

  return {
    config: readonly(config),
    fieldMappings: readonly(fieldMappings)
  };
}
